/* SET STATE */
export const SET_STATE_LABREQUESTTESTSAMPLE = "SET_STATE_LABREQUESTTESTSAMPLE"

/* LABREQUESTTESTSAMPLES */
export const GET_LABREQUESTTESTSAMPLES = "GET_LABREQUESTTESTSAMPLES"
export const GET_LABREQUESTTESTSAMPLES_SUCCESS = "GET_LABREQUESTTESTSAMPLES_SUCCESS"
export const GET_LABREQUESTTESTSAMPLES_FAIL = "GET_LABREQUESTTESTSAMPLES_FAIL"

/* LABREQUESTTESTSAMPLE */
export const GET_LABREQUESTTESTSAMPLE = "GET_LABREQUESTTESTSAMPLE"
export const GET_LABREQUESTTESTSAMPLE_SUCCESS = "GET_LABREQUESTTESTSAMPLE_SUCCESS"
export const GET_LABREQUESTTESTSAMPLE_FAIL = "GET_LABREQUESTTESTSAMPLE_FAIL"

/**
 * ADD LABREQUESTTESTSAMPLE
 */
 export const ADD_NEW_LABREQUESTTESTSAMPLE = "ADD_NEW_LABREQUESTTESTSAMPLE"
 export const ADD_LABREQUESTTESTSAMPLE_SUCCESS = "ADD_LABREQUESTTESTSAMPLE_SUCCESS"
 export const ADD_LABREQUESTTESTSAMPLE_FAIL = "ADD_LABREQUESTTESTSAMPLE_FAIL"

 /**
 * UPDATE LABREQUESTTESTSAMPLE
 */
export const UPDATE_LABREQUESTTESTSAMPLE = "UPDATE_LABREQUESTTESTSAMPLE"
export const UPDATE_LABREQUESTTESTSAMPLE_SUCCESS = "UPDATE_LABREQUESTTESTSAMPLE_SUCCESS"
export const UPDATE_LABREQUESTTESTSAMPLE_FAIL = "UPDATE_LABREQUESTTESTSAMPLE_FAIL"

/**
 * DELETE LABREQUESTTESTSAMPLE
 */
export const DELETE_LABREQUESTTESTSAMPLE = "DELETE_LABREQUESTTESTSAMPLE"
export const DELETE_LABREQUESTTESTSAMPLE_SUCCESS = "DELETE_LABREQUESTTESTSAMPLE_SUCCESS"
export const DELETE_LABREQUESTTESTSAMPLE_FAIL = "DELETE_LABREQUESTTESTSAMPLE_FAIL"
